import { Box, Text } from "@prismicio/editor-ui"

export type RequestFormInputBaseProps = { label: string; children: JSX.Element }

export function RequestFormInputBase(props: RequestFormInputBaseProps) {
  const { label, children } = props

  return (
    <Box display="grid" gap={8} gridTemplateColumns="1fr 3fr">
      <Box alignItems="center">
        <Text variant="smallBold" component="label" color="grey10">
          {label}
        </Text>
      </Box>
      {children}
    </Box>
  )
}
